export default {
  set(state, { data }) {
    state.products = data;
  },
  show(state, { data }) {
    state.product = data;
  }
}